<template>
  <div>
    <div class="admin">
      <!-- alerta -->
      <div
        class="alert alert-success text-center alert-top animated bounceInUp"
        v-if="alert"
        role="alert"
      >
        El producto se actualizó correctamente!
      </div>
      <!-- /alerta -->

      <div class="fluid-container">
        <div class="row no-gutters">
          <!-- menu admin -->
          <div class="col-3">
            <menu-admin></menu-admin>
          </div>
          <!-- menu admin -->

          <!-- main -->
          <div class="col-9 main pb-5">
            <div class="row">
              <div class="col-12 mb-2">
                <div class="title-admin">
                  <h1 class="display-2 font-weight-black">{{ nombre }}</h1>
                  <div class="acciones">
                    <v-btn large color="primary" to="/admin/agregar-producto">
                      <v-icon class="mr-3">add</v-icon>Agregar producto
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-8">
                <!-- producto form -->
                <div class="col-12 pb-5 mb-5">
                  <v-text-field
                    v-model="nombre"
                    label="Nombre del producto"
                    outlined
                    placeholder="nombre"
                  ></v-text-field>

                  <v-text-field
                    v-model="sku"
                    label="SKU"
                    outlined
                    placeholder="sku"
                  ></v-text-field>

                  <v-select
                    :items="categorias"
                    label="Categorías"
                    v-model="categoria"
                    outlined
                    item-text="nombre"
                    item-value="id"
                    placeholder="Selecciona la categoría"
                  ></v-select>

                  <div>
                    <v-text-field
                      v-model="precio_pesos"
                      label="Precio Regular"
                      outlined
                      placeholder="$"
                      hide-details
                    ></v-text-field>
                  </div>

                  <div>
                    <v-text-field
                      class="mt-7"
                      v-model="precio_pesos_oferta"
                      label="Precio Oferta"
                      outlined
                      placeholder="$"
                      hide-details
                    ></v-text-field>
                  </div>

                  <div style="margin-top: 30px">
                    <v-textarea
                      outlined
                      v-model="descripcion_espanol"
                      placeholder="Escribe la descripción del producto"
                      auto-grow
                      label="Descripción del producto en español"
                    ></v-textarea>
                  </div>

                  <v-textarea
                    outlined
                    v-model="descripcion_ingles"
                    placeholder="Escribe la descripción del producto"
                    auto-grow
                    label="Descripción del producto en inglés"
                  ></v-textarea>

                  <v-text-field
                    v-model="inventario"
                    label="Cantidad de productos en stock"
                    outlined
                    placeholder="inventario"
                    @change="changeToDollar()"
                    hide-details
                  ></v-text-field>

                  <v-switch
                    v-model="visible"
                    :label="
                      ` ${
                        visible
                          ? 'Si debe estar visible en la pagina web'
                          : 'No debe de estar visible en la pagina web'
                      }`
                    "
                  ></v-switch>

                  <v-btn class="mt-5" large color="primary" @click="validar()"
                    >guardar producto</v-btn
                  >
                </div>
                <!-- /producto form -->
              </div>

              <div class="col-4 pb-5">
                <!-- imagen destacada -->
                <div class="producto-imagenes">
                  <h5 class="mb-4">Imágen destacada</h5>

                  <!-- loader -->
                  <div
                    v-if="loaderDestacada"
                    class="text-center"
                    style="
                      height: 300px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <div
                      class="spinner-border text-primary"
                      style="width: 45px; height: 45px"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="imgDataUrl == ''">
                      <!-- imagen destacada no definida -->
                      <div class="imagen-no-definida mt-3">
                        <img
                          src="https://image.flaticon.com/icons/svg/137/137665.svg"
                          alt
                        />
                        <span>No se ha definido una imagen destacada</span>
                        <button
                          class="mt-2 btn btn-outline-secondary"
                          @click="toggleShow"
                        >
                          Subir imagen destacada
                        </button>
                      </div>
                      <!-- /imagen destacada no definida -->
                    </div>
                    <div v-else>
                      <img
                        class="shadow"
                        style="width: 100%"
                        :src="imgDataUrl"
                        alt
                      />
                      <button
                        class="mt-4 btn btn-outline-danger"
                        @click="eliminarImagenDestacada"
                      >
                        Eliminar imagen destacada
                      </button>
                    </div>
                  </div>
                </div>
                <!-- /imagen destacada -->

                <!-- galeria -->
                <div class="producto-imagenes mt-4">
                  <h5 class="mb-4">Galería de imagenes</h5>

                  <!-- loader -->
                  <div
                    v-if="loaderGaleria"
                    class="text-center"
                    style="
                      height: 300px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <div
                      class="spinner-border text-primary"
                      style="width: 45px; height: 45px"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <div v-else>
                    <!-- existen imagenes -->
                    <div v-if="imagenes != ''">
                      <div class="galeria-admin-sidebar">
                        <ul>
                          <li v-for="(item, index) in imagenes" :key="item.id">
                            <img :src="item.url" alt />
                            <span
                              v-on:click="removeElement(key, item.id)"
                              class="btn btn-block btn-outline-danger btn-sm"
                              style="border-radius: 0"
                              >Eliminar imagen</span
                            >
                          </li>
                        </ul>
                        <router-link
                          :to="'/admin/producto/' + id_producto + '/galeria'"
                          class="mt-0 btn btn-outline-secondary"
                          >Subir mas imagenes a la galería</router-link
                        >
                      </div>
                    </div>
                    <!-- /existen imagenes -->

                    <div v-else class="galeria">
                      <!-- galeria  no definida -->
                      <div class="imagen-no-definida mt-3">
                        <img
                          src="https://image.flaticon.com/icons/svg/137/137665.svg"
                          alt
                        />
                        <span>No se han agregado imágenes a la galería</span>
                        <router-link
                          :to="'/admin/producto/' + id_producto + '/galeria'"
                          class="mt-2 btn btn-outline-secondary"
                          >Subir imagenes a la galería</router-link
                        >
                      </div>
                      <!-- /galeria  no definida -->
                    </div>
                  </div>
                  <!-- /loader -->
                </div>
                <!-- /galeria -->

                <div class="btn mt-4 btn-secondary btn-lg btn-block">
                  Ver producto en la pagina
                </div>
                <div
                  class="btn mt-3 btn-danger btn-lg btn-block btn-icon"
                  @click="showAlert()"
                >
                  <i class="material-icons">delete</i>Eliminar producto
                </div>
              </div>
            </div>
          </div>
          <!-- /main -->
        </div>

        <div class="row">
          <div class="col-12">
            <my-upload
              field="destacada"
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="show"
              langType="es-MX"
              url="https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getImage"
              :width="900"
              :height="900"
              :params="params"
              :headers="headers"
              img-format="jpg"
            ></my-upload>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import { setTimeout } from "timers";
import myUpload from "vue-image-crop-upload";
const axios = require("axios");
export default {
  data() {
    return {
      alert: false,
      nombre: "",
      sku: "",
      categoria: "",
      categorias: "",
      precio_pesos: "",
      precio_pesos_oferta: "",
      precio_dolares: "",
      inventario: "",
      descripcion_ingles: "",
      descripcion_espanol: "",
      visible: "",
      error: "",
      loader: false,
      id_producto: this.$route.params.id,

      imagenes: "",
      loaderGaleria: true,
      loaderDestacada: true,

      how: true,
      params: {
        id: this.$route.params.id,
      },
      headers: {
        //smail: '*_~'
      },
      imgDataUrl: "", // the datebase64 url of created image,
      show: "",
    };
  },
  components: {
    "my-upload": myUpload,
  },
  methods: {
    getCategorias() {
      //Obtenemos los productos
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getCategorias"
        )
        .then((response) => {
          this.categorias = response.data;
          this.loader = false;
        })
        .catch((error) => console.log(error));
    },
    validar() {
      if (this.nombre == "") {
        this.$swal({
          type: "error",
          title: "Ingresa el nombre del producto",
          showConfirmButton: true,
        });
      } else if (this.sku == "") {
        this.$swal({
          type: "error",
          title: "Ingresa el SKU del producto",
          showConfirmButton: true,
        });
      } else if (this.categoria == "" || this.categoria == "selected") {
        this.$swal({
          type: "error",
          title: "Selecciona la categoría del producto",
          showConfirmButton: true,
        });
      } else if (this.precio_pesos == "") {
        this.$swal({
          type: "error",
          title: "Selecciona el precio del producto en pesos",
          showConfirmButton: true,
        });
      } else if (this.inventario == "") {
        this.error = this.$swal({
          type: "error",
          title: "Selecciona la cantidad de productos en stock",
          showConfirmButton: true,
        });
      } else {
        //Los datos requeridos se ingresaron
        this.actualizar();
      }
    },

    actualizar() {
      this.loader = true;
      if (this.visible) {
        this.visible = 1;
      } else {
        this.visible = 0;
      }

      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=updateProducto" +
            "&id=" +
            this.id_producto +
            "&nombre=" +
            this.nombre +
            "&sku=" +
            this.sku +
            "&categoria=" +
            this.categoria +
            "&inventario=" +
            this.inventario +
            "&precio_pesos=" +
            this.precio_pesos +
            "&precio_oferta_pesos=" +
            this.precio_pesos_oferta +
            "&precio_dolares=" +
            this.precio_dolares +
            "&descripcion_espanol=" +
            this.descripcion_espanol +
            "&descripcion_ingles=" +
            this.descripcion_ingles +
            "&visible=" +
            this.visible
        )
        .then((response) => {
          this.loader = false;
          this.$swal({
            type: "success",
            title: "El producto se actualizó exitosamente",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((error) => console.log(error));
    },
    getProductoGaleria() {
      //Obtenemos los datos del producto
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getProductoGaleria&id=" +
            this.id_producto
        )
        .then((response) => {
          console.log(response.data);
          this.loaderGaleria = false;
          this.imagenes = response.data;
        })
        .catch((error) => console.log(error));
    },
    getProductoData() {
      //Obtenemos los datos del producto
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getProductoData&id=" +
            this.id_producto
        )
        .then((response) => {
          this.categoria = response.data.categoria_id;
          this.nombre = response.data.nombre;
          this.precio_pesos = response.data.precio_pesos;
          this.precio_dolares = response.data.precio_dolares;
          this.sku = response.data.sku;
          this.inventario = response.data.inventario;
          this.descripcion_ingles = response.data.descripcion_ingles;
          this.descripcion_espanol = response.data.descripcion_espanol;
          this.imgDataUrl = response.data.imagen_destacada;
          this.visible = response.data.visible;
          this.precio_pesos_oferta = response.data.precio_oferta_pesos;

          if (this.visible == 1) {
            this.visible = true;
          } else {
            this.visible = false;
          }

          this.loaderDestacada = false;
        })
        .catch((error) => console.log(error));
    },

    eliminarImagenDestacada() {
      this.loaderDestacada = true;
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=eliminarImagenDestacada&id=" +
            this.id_producto
        )
        .then((response) => {
          this.loaderDestacada = false;
          this.imgDataUrl = "";
        })
        .catch((error) => console.log(error));
    },

    toggleShow() {
      this.show = !this.show;
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field) {
      console.log("-------- crop success --------");
      this.imgDataUrl = imgDataUrl;
      this.loaderDestacada = true;
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {
      this.loaderDestacada = false;
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },
    removeElement(index, id) {
      this.loaderGaleria = true;
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=eliminarFotoGaleria&id=" +
            id
        )
        .then((response) => {
          this.imagenes.splice(index, 1);
          this.loaderGaleria = false;
          this.alert = true;
          setTimeout(() => (this.alert = false), 3000);
        })
        .catch((error) => console.log(error));
    },
    deleteProducto() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=deleteProducto&id=" +
            this.id_producto
        )
        .then((response) => {
          this.$swal({
            type: "success",
            title: "El producto se borró exitosamente",
            showConfirmButton: false,
            timer: 1500,
          });

          setTimeout(
            () =>
              router.push({
                name: "productos_admin",
              }),
            1500
          );
        })
        .catch((error) => console.log(error));
    },
    showAlert() {
      // Use sweetalert2
      this.$swal({
        title: "Estás seguro que deseas eliminar el producto",
        text: "No podrás deshacer este cambio!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, estoy seguro!",
        cancelButtonText: "No!",
      }).then((result) => {
        if (result.value) {
          //Enviamos petición al servidor
          this.deleteProducto();
        }
      });
    },
  },
  computed: {},
  mounted() {
    this.getProductoGaleria();
    this.getProductoData();
    this.getCategorias();
  },
};
</script>
